export default __webpack_public_path__ + "static/media/play2.c99d9a73.gif";